import { derive } from 'store-utils';
import createIrrelevantAppsInfo from '../utils/irrelevant-apps-info';
import { createStore } from 'store-utils';
import {
  ERelevance,
  IrrelevantApp,
  RawIrrelevantApp,
  Result,
} from '../irrelevant-apps-types';
import { Nullable } from 'common-types';
import { createAsyncState } from 'async-utils';

const baseStore = createStore<IrrelevantAppsStoreState>(
  {
    apps: [],
    generalError: false,
    errorMessage: null,
    isLoading: true,
    showMakeRelevantDialog: false,
    isRemoveIrrelevantAppLoading: false,
    loading: createAsyncState(),
    selectedReleventApp: null,
    relevntModal: false,
    isLoadingRelevet: false,
    releventType: ERelevance.Relevant,
  },
  'Irrelevant Apps Store',
);

export const IrrelevantAppsStore = derive(
  {
    irrelevantApps: (get): Result => {
      const { apps } = get(baseStore);
      return createIrrelevantAppsInfo(apps);
    },
  },
  {
    proxy: baseStore,
  },
);

export default IrrelevantAppsStore;

export interface IrrelevantAppsStoreState {
  apps: RawIrrelevantApp[];
  generalError: boolean;
  errorMessage: Nullable<string>;
  isLoading: boolean;
  showMakeRelevantDialog: boolean;
  isRemoveIrrelevantAppLoading: boolean;
  loading: ReturnType<typeof createAsyncState>;
  selectedReleventApp: Nullable<IrrelevantApp>;
  relevntModal: boolean;
  isLoadingRelevet: boolean;
  releventType: ERelevance;
}
